import { Injectable } from '@angular/core';
import { SettingSelectors } from '@app/store/setting/setting.selectors';
import { Store } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { OS } from '@app/shared/enum/date';
import { StorageEnum } from '@app/shared/enum/storage';

interface KidsModel {
  save: (name: string) => void;
  cancel: (name: string) => void;
  confirmation: (trigger: true) => void;
  leavePage: (trigger: boolean) => void;
  unauthentication: (trigger: boolean) => void;
}

interface KidsRender {
  onRenderingCompleted: (trigger: number) => void;
}

interface KidsEvent {
  onGoBack: () => void
  onOpenFile: (link: string, mineType: string, fileName: string) => void;
  onSpinner: (flg: boolean) => void
}

declare var Kids: KidsModel;
declare var KIDSRender: KidsRender;
declare var KidsEvent: KidsEvent;

const resetZoom = 'reset=zoom';
@Injectable({
  providedIn: 'root',
})
export class WebviewService {
  isEditingKey: string = 'note-editing';
  private os = OS;
  constructor(
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute) { }

  private navBackHiddenName = 'hidden-nav-back';
  get isWebView(): boolean {
    // let isWebView = this.store.selectSnapshot(SettingSelectors.isWebView);
    // return isWebView || false;
    return true;
  }
  //#region ios messageHandlers
  get messageHandlers(): any | null {
    return (window as any)?.webkit?.messageHandlers || null;
  }

  get iosListener(): any | null {
    return this.messageHandlers?.iosListener || null;
  }

  get shouldShowLocalConfirmation(): any | null {
    return this.messageHandlers?.shouldShowLocalConfirmation || null;
  }

  get headerChange(): any | null {
    return this.messageHandlers?.headerChange;
  }

  get unauthentication(): any | null {
    return this.messageHandlers?.unauthentication;
  }

  get errorCatcher(): any | null {
    return this.messageHandlers?.errorCatcher;
  }

  get renderDone(): any | null {
    return this.messageHandlers?.renderDone;
  }
  get _nativeGoBack(): any | null {
    return this.messageHandlers?.onGoBack;
  }
  get triggerSpinner(): any | null {
    return this.messageHandlers?.onSpinner;
  }
  get viewport() {
    const viewport = document.querySelector('meta[name="viewport"]');
    return viewport;
  }
  get onOpenFile(): any | null {
    return this.messageHandlers?.onOpenFile;
  }
  //#endregion

  triggerWebView() {
    // this.emitConfig({ reset: 'zoom' });
    this.iosWebkitTrigger();
    // setTimeout(() => { this.emitConfig({ reset: null }) }, 200)
  }

  private iosWebkitTrigger() {
    this.iosListener?.postMessage(resetZoom);
  }

  private emitConfig(config: any) {
    this.router.navigate(
      [],
      {
        replaceUrl: true,
        relativeTo: this.activatedRoute,
        queryParams: config,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      }
    );
  }

  kidsConfirmDialogIntercepter(flg: boolean = true) {
    const isWebview = this.store.selectSnapshot(SettingSelectors.isWebView);
    if (!isWebview) return;
    if (flg) {
      localStorage.setItem('is-confirm', '1');
      this.shouldShowLocalConfirmation?.postMessage(false);

    } else {
      localStorage.removeItem('is-confirm');
      this.shouldShowLocalConfirmation?.postMessage(true);
    }
    // ios case
    if (this.iosListener) {
      this.iosListener?.postMessage(!flg);
    }
    // android case
    try {
      if (Kids) {
        Kids?.leavePage(!flg);
      }
    } catch (error) {

    }

  }

  kidsCancel(name: string) {
    const webkit = (window as any).webkit;
    if (webkit?.messageHandlers?.kidsCancel) {
      // for iOS
      webkit.messageHandlers.kidsCancel.postMessage(name);
    } else {
      // for Android
      if (Kids) {
        Kids.cancel(name);
      }
    }
  }

  kidsSave(name: string) {
    const webkit = (window as any).webkit;
    if (webkit?.messageHandlers?.kidsSave) {
      // for iOS
      webkit.messageHandlers.kidsSave.postMessage(name);
    } else {
      // for Android
      if (Kids) {
        Kids.save(name);
      }
    }
  }

  kidsWarningBeforeChangePageIndicator(add: boolean) {
    if (add) {
      localStorage.setItem(this.isEditingKey, '1');
      // change url
      this.emitConfig({ 'note-editing': '1' });
    } else {
      localStorage.removeItem(this.isEditingKey);
      // change url
      this.emitConfig({ 'note-editing': null });
    }
  }

  navBackLockAssit() {
    localStorage.setItem(this.navBackHiddenName, '1');
  }

  navBackUnlockAssit() {
    localStorage.removeItem(this.navBackHiddenName);
  }

  get isNavLock() {
    return localStorage.getItem(this.navBackHiddenName) == '1';
  }

  kidsHeaderNameIos(name: string, isBackable: string) {
    if (!name) {
      localStorage.removeItem(StorageEnum.HEADER);
      this.headerChange?.postMessage([]);
      return;
    }
    this.headerChange?.postMessage([name, isBackable].filter(x => x !== '').join('-'));
    localStorage.setItem(StorageEnum.HEADER, name);
  }

  kidsLogoutSignal() {
    try {
      const webkit = (window as any).webkit;
      if (webkit?.messageHandlers?.logout) {
        // for iOS
        webkit.messageHandlers.logout.postMessage(1);
      }
    } catch (error) {
      console.log(error);
    }
  }

  getMobileOS = () => {
    const isWebview = this.store.selectSnapshot(SettingSelectors.isWebView);
    if (isWebview) {
      const ua = navigator.userAgent
      if (/android/i.test(ua)) {
        return this.os.ANDROID;
      }
      else if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return this.os.IOS;
      }
    }
    return this.os.OTHERS;
  }

  kidsExpireToken() {
    if (this.isWebView) {
      try {
        if (this.unauthentication) {
          // for iOS
          this.unauthentication?.postMessage(true);
        }
        if (Kids) {
          // for android
          Kids.unauthentication(true);
        }
        this.kidsError('401');
        // this.router.navigate(['/404'], { skipLocationChange: true });
      } catch (error) {
        console.log(error);
      }

    }
  }
  
  /**
   * 
   * @param err stringtified json
   */
  kidsError(err: string) {
    if (this.errorCatcher) {
      this.errorCatcher.postMessage(err);
    }
  }

  kidsRenderDone() {
    try {
      if(this.renderDone) this.renderDone.postMessage(1);
      if (KIDSRender) KIDSRender.onRenderingCompleted(1);
    } catch (error) { }
  }

  nativeGoBack() {
    try {
      if (this._nativeGoBack) this._nativeGoBack.postMessage(1);
      if (KidsEvent) KidsEvent.onGoBack();
    } catch (error) { }
  }

  resetZoom() {
    if (this.viewport) {
      this.viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no');
    }
  }

  releaseZoom() {
    if (this.viewport) {
      this.viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=yes');
    }
  }
  triggerSpinnerMobile(flg: boolean): boolean {
    try {
      if (this.triggerSpinner) {
        // for iOS
        this.triggerSpinner?.postMessage(flg);
      }
      if (KidsEvent) {
        // for android
        KidsEvent.onSpinner(flg);
      }
      return true
    } catch (error) {
      console.log(error);
      return false
    }
  }
}
